export default __webpack_public_path__ + "static/media/it_6.1c9f47aa.mp3";